// extracted by mini-css-extract-plugin
export default {"row":"DocumentTypeField-module--row--HNSOu","value":"DocumentTypeField-module--value--q5bNY"};